import { Page } from './HostfullyAssistMarketing.styles';
import HeroSection from './sections/HeroSection';
import InboxSection from './sections/InboxSection';
import FeaturesSection from './sections/FeaturesSection';
import BenefitsSection from './sections/BenefitsSection';
import ClosingSection from './sections/ClosingSection';
import FaqsSection from './sections/FaqsSection';

const HostfullyAssistMarketing = () => {
  return (
    <Page data-testid="hostfully-assist">
      <HeroSection />
      <InboxSection />
      <FeaturesSection />
      <BenefitsSection />
      <ClosingSection />
      <FaqsSection />
    </Page>
  );
};

export default HostfullyAssistMarketing;
